module.exports = __webpack_public_path__ + "img/yfx.5afc5233.png";